"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSet = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var ChartBar_1 = require("../ChartBar/ChartBar");
var ChartLine_1 = require("../ChartLine/ChartLine");
var ChartTooltip_1 = require("../ChartTooltip/ChartTooltip");
var ChartSet_styled_1 = require("./ChartSet.styled");
/**
 * A top level entry in the chart, which may be contain several "Bars".
 */
var ChartSet = function (_a) {
    var _b;
    var set = _a.set, scale = _a.scale, scrollRef = _a.scrollRef, legend = _a.legend, _c = _a.barWidth, barWidth = _c === void 0 ? '1rem' : _c, rest = __rest(_a, ["set", "scale", "scrollRef", "legend", "barWidth"]);
    var Small = (0, core_1.useComponents)().Small;
    var _d = __read((0, react_1.useState)(false), 2), tooltipVisible = _d[0], setTooltipVisible = _d[1];
    var setRef = (0, react_1.createRef)();
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.CHART_SET, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(ChartSet_styled_1.StyledSet, __assign({ tabIndex: 0, "aria-label": set.description, role: "listitem", onMouseEnter: set.tooltip ? function () { return setTooltipVisible(true); } : undefined, onMouseLeave: set.tooltip ? function () { return setTooltipVisible(false); } : undefined, onFocus: set.tooltip ? function () { return setTooltipVisible(true); } : undefined, onBlur: set.tooltip ? function () { return setTooltipVisible(false); } : undefined, onClick: set.onClick, 
            // Enter key pressed.
            onKeyUp: function (event) {
                return event.keyCode === 13 && set.onClick && set.onClick();
            }, clickable: !!set.onClick, ref: setRef }, rest),
            react_1.default.createElement(ChartSet_styled_1.StyledSetLabel, { as: Small, "aria-hidden": "true" }, set.label),
            set.tooltip ? (react_1.default.createElement(ChartTooltip_1.ChartTooltip, { visible: tooltipVisible, scrollRef: scrollRef, setRef: setRef }, set.tooltip)) : null,
            react_1.default.createElement(ChartSet_styled_1.StyledSetBars, { "aria-hidden": "true", barWidth: barWidth },
                set.lines ? (react_1.default.createElement(ChartSet_styled_1.StyledSetLines, null, set.lines.map(function (line, key) { return (react_1.default.createElement(ChartLine_1.ChartLine, { barWidth: barWidth, line: line, key: "line-".concat(key), "data-testid": "chart-line", scale: scale, legend: legend })); }))) : null,
                set.bars.map(function (bar, key) { return (react_1.default.createElement(ChartBar_1.ChartBar, { barWidth: barWidth, bar: bar, key: "bar-".concat(key), "data-testid": "chart-bar", scale: scale, legend: legend })); })))));
};
exports.ChartSet = ChartSet;
